export function getCategoryPath(path: string[], displayText?: string) {
    return displayText ? [...path, displayText ?? ''] : path;
}

export function trackCategoryPath(path: string[]) {
    return path.join(' | ');
}
